export type DeputyPerson = {
  isPrimary: boolean;
  firstName: string | null;
  lastName: string | null;
  dateOfBirth: string | null;
  identificationNumber: string | null;
  personalIdType: string | null;
  personalIdNumber: string | null;
  validUntil: string | null;
  issuedBy: string | null;
};
